module.exports = __webpack_public_path__ + "static/media/elecphone.9889aa4e.jpg";